module.exports = {
  alt: require('./alt'),
  ap: require('./ap'),
  bimap: require('./bimap'),
  bichain: require('./bichain'),
  both: require('./both'),
  chain: require('./chain'),
  coalesce: require('./coalesce'),
  compareWith: require('./compareWith'),
  concat: require('./concat'),
  cons: require('./cons'),
  contramap: require('./contramap'),
  either: require('./either'),
  empty: require('./empty'),
  equals: require('./equals'),
  extend: require('./extend'),
  filter: require('./filter'),
  first: require('./first'),
  fold: require('./fold'),
  foldMap: require('./foldMap'),
  head: require('./head'),
  init: require('./init'),
  last: require('./last'),
  map: require('./map'),
  merge: require('./merge'),
  option: require('./option'),
  promap: require('./promap'),
  reduce: require('./reduce'),
  reduceRight: require('./reduceRight'),
  reject: require('./reject'),
  run: require('./run'),
  runWith: require('./runWith'),
  second: require('./second'),
  sequence: require('./sequence'),
  swap: require('./swap'),
  tail: require('./tail'),
  traverse: require('./traverse'),
  valueOf: require('./valueOf')
}
